import _ from 'underscore'
import TestViewTemplate from '../../../templates/test.tpl'
import config from '../../../config'
import TestView from '../../../views/test'

const FrpTestView = TestView.extend({
    initialize() {
        this.template = _.template(TestViewTemplate)

        // reset the test model
        this.model.get('test').reset()

        // set the mode
        this.model.set('mode', 'test')

        // create methodology and problem question arrays
        const questions = this.model.get('question_list')
        const fluency = questions.filter(q => q.question_list[0].tag === 'f')
        const reasoning = questions.filter(q => q.question_list[0].tag === 'r')
        const problem = questions.filter(q => q.question_list[0].tag === 'p')

        const randomFluency = _.sample(fluency, 2)
        const randomReasoning = _.sample(reasoning, 2)
        const randomProblem = _.sample(problem, 1)

        const randomQuestions = config.get('testMode') ? questions : randomFluency.concat(randomReasoning, randomProblem)

        // load them into the test model
        this.model.get('test').set({
            questions: randomQuestions,
            start_timestamp: new Date().getTime(),
        })

        // if this model changes it means the user has answered so show
        // the next question button AND explanation
        this.listenTo(this.model.get('test'), 'change', this.questionAnswered)
    },
})

export default FrpTestView
